import { ResourceBuilder } from '../../core/resource-builder'
import type { MessagesResponse } from './model'

type MessagesRequestsConfig = {
  get: {
    request: {
      limit?: number
      offset?: number
    }
    response: MessagesResponse
  }
}

export default new ResourceBuilder<MessagesRequestsConfig>('messages')
